module.exports = __webpack_public_path__ + "static/media/Artboard27.4a9bafb6.png";